import React, { Component } from 'react';
import dayjs from 'dayjs';
import { TableGrid } from '@C/TableGrid';
import services from '@C/Director/Packages/_utils/data';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'created_on',
    type: 'date',
  },
  {
    name: 'Package',
    key: 'plan',
  },
  {
    name: 'Plan',
    key: 'plan_type',
  },
  {
    name: 'Price',
    key: 'price',
  },
];

export default class ExistingPlans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      existingPlans: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.getPackages();
  }

  getPackages = () => {
    services
      .getPackages()
      .then((response) => {
        const tmp = response.data.data;
        const flattenedPlans = tmp.flatMap((plan) =>
          plan.plan_structure.map((structure) => ({
            ...structure,
            plan: plan.plan,
          })),
        );

        this.setState({
          existingPlans: flattenedPlans,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const { existingPlans, loading } = this.state;

    return (
      <>
        <section className="widget full-width list-table">
          <header>
            <h3> Existing Plans </h3>
          </header>
          <main className="list-content">
            <div className="table-wrapper --full">
              {loading ? (
                <DropLoaderLarge />
              ) : (
                <TableGrid
                  col={col}
                  row={existingPlans}
                  hideActions={true}
                  pagination="disabled"
                  enableExport={false}
                />
              )}
            </div>
          </main>
        </section>
      </>
    );
  }
}
